import SearchVerb from './SearchVerb';

export default SearchVerb;



// WEBPACK FOOTER //
// ./src/components/SearchVerb/index.js